import { ViewportInstance } from "./ViewportInstance";
import { getTexture } from "../assets/assets";
import { Texture, Sprite, Rectangle, Container, Spritesheet, Ticker, Filter, RenderTexture } from "pixi.js";
import { app , mainContainer, mobileView,} from "../app";

type viewportSpriteVariables = {
    destContainer: Container,
    spriteRef: string,
    perX?: number,
    perY?: number,
    minWidth?: number| undefined,
    minHeight?: number | undefined,
    clickFunction?: () => void
    customFilters?: Filter[],
    secondaryRef?: string,
    hitAreaMult?: number
}

export class ViewportSprite extends ViewportInstance {

    private spriteRef: string;
    private sprite: Sprite | undefined;
    private _rotate: number| undefined = undefined;
    private _rotationAmount: number = 0;
    private spritesheet?: Texture[] | undefined;
    private secondarySheet?: Texture[] | undefined;
    

    
    private animationTicker;
    
    public get rotationAmount(): number {
        return this._rotationAmount;
    }
    public set rotationAmount(value: number) {
        this._rotationAmount = value;
    }
    
    public set rotate(value: number) {
        this._rotate = value;
        



        if (value !== undefined) app.ticker.add(() => {
            this.rotationAmount += value + value*this.pressed*10;
            
            this.attachment.rotation = this.rotationAmount;

            let b = this.attachment.getLocalBounds();
            let pixelHeight, pixelWidth;
            if (this.height) {
                pixelHeight = this.height*app.screen.height;
            } else {
                pixelWidth = this.width*app.screen.width;
            }
            
            
            // const mobileMult = (mobileView) ? 2 : 1;
            const scale = pixelHeight? pixelHeight/b.height : pixelWidth!/b.width;
            const width = this.attachment.texture.width*scale
            const height = this.attachment.texture.height*scale

            this.filterArea =  new Rectangle(this.x-width/2,this.y-height/2,width,height)
        })

        
    }

    constructor(
        {
            destContainer,
            spriteRef,
            perX,
            perY,
            minWidth,
            minHeight,
            clickFunction,
            customFilters,
            secondaryRef,
            hitAreaMult
        }:viewportSpriteVariables
    ){
        super(destContainer);
        this.spriteRef = spriteRef;
        this.perX = perX ?? 0.5;
        this.perY = perY ?? 0.5;
        this.destX = perX ?? 0.5;
        this.destY = perY ?? 0.5;
        super.minWidth = minWidth ?? undefined;
        super.minHeight = minHeight ?? undefined;
        if (hitAreaMult) super.hitAreaMult = hitAreaMult;
        if (customFilters) super.customFilters = customFilters;

        if (secondaryRef) {
            const secondaryTexture = getTexture(secondaryRef);
            if (secondaryTexture && secondaryTexture instanceof Spritesheet) {
                this.secondarySheet = Object.values(secondaryTexture.textures)
            } 
        }


        super.clickFunction = clickFunction;

        let lastTick = 0;
        let frame:number = 0;
        let secondaryFrame: number = 0
        const fps = 16;
        const ticksPerFrame = 1000/fps;
        
        let spriteContainer: Container = new Container();;
        let firstSprite: Sprite; 
        
        let secondSprite: Sprite;
        let combinedRenderTexture: RenderTexture;
        let fixedRegion;
        
        if (this.secondarySheet) {
            // firstSprite = new Sprite(this.spritesheet?.[frame])
            // firstSprite.anchor.set(0.5,0.5)
            firstSprite = new Sprite(this.spritesheet?.[frame]);
            firstSprite.anchor.set(0.5,0.5);
            secondSprite = new Sprite(this.secondarySheet?.[secondaryFrame])
            secondSprite.anchor.set(0.5,0.5)
            secondSprite.blendMode = 'screen';
            spriteContainer.addChild(firstSprite, secondSprite)
        } else {
            firstSprite = new Sprite(this.spritesheet?.[frame]);
            spriteContainer.addChild(firstSprite)
            firstSprite.anchor.set(0.5,0.5);
        }
        
        combinedRenderTexture = RenderTexture.create({width: 250, height: 250});

        this.animationTicker = (ticker: Ticker) => {
            if (this.spritesheet) firstSprite.texture = this.spritesheet?.[frame];
            // fixedRegion = [firstSprite.width, firstSprite.height];
            spriteContainer.position.set(125, 125);
            
            
            if (!this.spritesheet || !this.sprite) {
                app.ticker.remove(this.animationTicker)
                return;
            }
            lastTick += ticker.deltaMS;
            
            if (lastTick < ticksPerFrame) {
                return;
            } else {
                lastTick = 0;
            } 
            const frameCount = this.spritesheet.length;
            if (frame === frameCount - 1) {
                frame = 0
            } else {
                frame++;
            }
            if (this.pressed > 0) {
                for ( let i = 0; i < 3; i++) {
                    if (frame === frameCount - 1) {
                        frame = 0
                    } else {
                        frame++;
                    }
                }
                
            }

            if (this.secondarySheet) {
                const secondaryFrameCount = this.secondarySheet?.length;
                if (secondaryFrame === 0) {
                    secondaryFrame = secondaryFrameCount-1
                } else {
                    secondaryFrame--
                }
            }
            

            if (!this.secondarySheet) {
                firstSprite.scale = 1-this.pressed/3.5
            } else {
                secondSprite.texture = this.secondarySheet?.[secondaryFrame]
                firstSprite.scale = 1-this.pressed/2.2
                firstSprite.rotation += 0.002+this.pressed*0.1
            }

            app.renderer.render({
                container: spriteContainer,
                target: combinedRenderTexture,
                clear: true 
            });
            this.sprite.texture = combinedRenderTexture;
            
        };

        const texture = getTexture(spriteRef);
        if (texture) {
            if (texture instanceof Texture) {
                this.attachSprite(texture);
            } else if (texture instanceof Spritesheet) {
                this.spritesheet = Object.values(texture.textures)
                this.attachSprite(this.spritesheet[0])
                app.ticker.add(this.animationTicker)
            } 
        } else {
            console.error(texture)
        }

        // console.log("SPRITE ATTACHMENT "+this.attachment)
        // console.log(this.attachment)
        super.init();


    }

    updatePixel(): void {
        super.updatePixel();
        if (this.sprite) {
            this.sprite.x = super.x;
            this.sprite.y = super.y;
            // console.log("My bunny ass self:")
            // console.log(this.sprite.x+ " : " + this.sprite.y)
        }
    }

    attachSprite(texture: Texture) {
        
        this.sprite = Sprite.from(texture);
        
        const bounds = this.sprite.getLocalBounds();
        this.sprite.pivot.set(
            bounds.x + bounds.width / 2,
            bounds.y + bounds.height / 2
        );
        const r = app.renderer.resolution;

        this.sprite.filterArea = new Rectangle(
             bounds.x * r,
             (bounds.y) * r,
             bounds.width,
             (bounds.height)
        );



        // this.addChild(this.sprite)
        this.addChild(this.sprite)
        this.sprite.zIndex = 100;
        // mainContainer.addChild(this)
        console.log("SPRITE BEING ATTACHED!!!!!")
        console.log(this.sprite)
        super.attachment = this.sprite;
        

    }
}